import { useQuery } from 'react-query'

import type { InteractionProps } from '../../../../pages/painel/Interacoes/interfaces'
import type { InteractionsFiltersDomain } from '../../../../types/domain/interactions-filters-domain'
import {
  getValidInteractionFilters,
} from '../../../../types/domain/interactions-filters-domain'
import type InteractionsPaginationDomain from '../../../../types/domain/interactions-pagination-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { getQueryStrinfied } from '../../../../utils/query'
import { api } from '../../../api'

export const fetchInteractions = async (filters: InteractionsFiltersDomain) => {
  const query = getQueryStrinfied(getValidInteractionFilters(filters))
  const { data } = await api.get<InteractionsPaginationDomain>(
    `/interactions?${query}`,
  )
  return data
}

export const fetchInteractionsForExport = async (
  filters: InteractionsFiltersDomain,
) => {
  const query = getQueryStrinfied(getValidInteractionFilters(filters))
  const { data } = await api.get<InteractionProps[]>(
    `/interactions/export?${query}`,
  )
  return data
}

export const fetchInteractionColumnValues = async (
  column: string,
  filters: InteractionsFiltersDomain,
  page: number,
  search: string,
) => {
  const base = getValidInteractionFilters(filters)
  const query = getQueryStrinfied({
    ...base,
    column,
    page,
    take: 50,
    search,
  })
  const { data } = await api.get<PaginationDomain<{ id: number; value: string }>>(
    `/interactions/get-column-values?${query}`,
  )
  return data
}

export const useInteractionsQuery = (filters: InteractionsFiltersDomain) => {
  return useQuery(
    ['interactions', filters],
    () => fetchInteractions(filters),
    { staleTime: 1000 * 60 * 5, keepPreviousData: true },
  )
}
